import { jwtDecode } from 'jwt-decode';

const getToken = () => localStorage.getItem('token');
const setToken = (token) => localStorage.setItem('token', token);
const removeToken = () => localStorage.removeItem('token');

// jwtDecode lê base64url; o atob de antes falhava em tokens com "-" ou "_" e
// tratava a falha como token vencido.
const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return exp ? Date.now() / 1000 > exp : false;
  } catch {
    return true;
  }
};

const getUser = () => {
  try {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    if (!token || !userStr) return null;

    if (isTokenExpired(token)) {
      clearUser();
      removeToken();
      return null;
    }

    return JSON.parse(userStr);
  } catch {
    clearUser();
    removeToken();
    return null;
  }
};

const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('role', user.role);
};

const clearUser = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('role');
};

const getRole = () => localStorage.getItem('role');

// Dados do token sem checar validade (para mostrar quem está logado).
const getTokenPayload = () => {
  try {
    return jwtDecode(getToken());
  } catch {
    return null;
  }
};

export { getToken, setToken, removeToken, getUser, setUser, clearUser, getRole, isTokenExpired, getTokenPayload };
